import { httpGetAndParse } from '../../../utils/fetchService';

export const fetchAccountDetails = ({
  taxYear,
  period,
  orgId,
  jurisdictionId,
  categoryId,
  accountId,
}) =>
  httpGetAndParse({
    route: `/api/shared/account-details/${taxYear}/${period}/${orgId}/${jurisdictionId}/${categoryId}/${accountId}`,
    errorMessage: 'Fetching account details failed',
  });
